import type React from "react";
import type { CardProps } from "./Card.model";
import { StyledCard } from "./Card.styled";

export const Card: React.FC<CardProps> = ({ children, onClick, dataCy }) => (
  <StyledCard data-cy={dataCy} onClick={(event) => onClick?.(event)}>
    {children}
  </StyledCard>
);
